module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.9b5f51e3.jpeg";